export default __webpack_public_path__ + "static/media/logo.7c56cf67.png";